var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.value),function(nav,index){return _c('span',{key:index,staticClass:"pr-4 navItem",on:{"click":function($event){return _vm.navigate(nav)}}},[_c('v-icon',{attrs:{"size":"20"}},[_vm._v("arrow_back")]),_vm._v(" "),_c('span',{staticClass:"subheading"},[_vm._v(" "+_vm._s(nav.text))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }